var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "CompassTooltip",
        {
          attrs: {
            content: _vm.getExtensionOptionLabel(),
            delay: { show: 0, hide: 1 },
            disabled: _vm.disabled,
            placement: "top"
          }
        },
        [
          _c("CompassIconButton", {
            ref: "imageRichTextTrigger",
            attrs: {
              icon: _vm.getExtensionOptionIcon(),
              disabled: _vm.disabled,
              active: _vm.activeStyle(_vm.option) || _vm.isVisible,
              size: "small"
            },
            on: {
              click: function($event) {
                return _vm.updateVisibility(!_vm.isVisible)
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassPopover",
        {
          attrs: {
            isVisible: _vm.isVisible,
            title: _vm.$t.__("richText.customoptions.ImageRichText.add_image"),
            customClass: "image-richtext-popover",
            triggerRef: "imageRichTextTrigger"
          },
          on: {
            close: function($event) {
              return _vm.updateVisibility(false)
            }
          }
        },
        [
          [
            _c(
              "div",
              { staticClass: "image-richtext-popover__content" },
              [
                _c(
                  "CompassFormItem",
                  {
                    staticClass: "image-richtext-popover__form-item",
                    attrs: {
                      label: _vm.$t.__(
                        "richText.customoptions.ImageRichText.link"
                      ),
                      error: _vm.inputError
                    }
                  },
                  [
                    _c("CompassInput", {
                      ref: "imageRichtextInput",
                      staticClass: "image-richtext-popover__input",
                      attrs: {
                        isEraseable: true,
                        error: !!_vm.inputError,
                        type: "text"
                      },
                      on: {
                        input: _vm.resetInputError,
                        change: _vm.insertImage
                      },
                      model: {
                        value: _vm.imageSrc,
                        callback: function($$v) {
                          _vm.imageSrc = $$v
                        },
                        expression: "imageSrc"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "image-richtext-popover__buttons" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary",
                        size: "small"
                      },
                      on: {
                        click: function($event) {
                          return _vm.updateVisibility(false)
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.validate"),
                        disabled: !!!_vm.imageSrc,
                        size: "small"
                      },
                      on: { click: _vm.insertImage }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }